import { BASE_FONT_SIZE } from '@styles/constants'

export const _toRem = (size: number | undefined) => {
  if (typeof size === 'undefined') return false
  if (size === 0) return 0
  return `${(size / BASE_FONT_SIZE).toFixed(4)}rem`
}

export const _toRemSoft = (val: number | string) => (typeof val === 'number' ? _toRem(val) : val)

export const r = (size: number | undefined): string => _toRem(size).toString() ?? ''
